const INCIDENCE_ICON_COLORS = {
  light_blue: '#2DB2FD',
  orange: '#EE8306',
  red: '#FF3B30',
  green: '#3BB8A8',
  light_purple: '#6155F5',
};

export const INCIDENCE_ICONS = {
  'Permiso con goce de sueldo': {
    icon: 'currency-usd',
    color: INCIDENCE_ICON_COLORS.light_blue,
  },
  'Incapacidad pagada por la empresa': {
    icon: 'emoticon-sick-outline',
    color: INCIDENCE_ICON_COLORS.light_blue,
  },
  'Licencia 140 Bis': {
    icon: 'clipboard-text',
    color: INCIDENCE_ICON_COLORS.light_blue,
  },
  'Enf. Gral/Acc. Fuera trab.': {
    icon: 'emoticon-frown-outline',
    color: INCIDENCE_ICON_COLORS.orange,
  },
  Retardos: {
    icon: 'clock-outline',
    color: INCIDENCE_ICON_COLORS.orange,
  },
  'Permiso sin goce de sueldo': {
    icon: 'currency-usd-off',
    color: INCIDENCE_ICON_COLORS.red,
  },
  'Accidente de trabajo': {
    icon: 'medical-bag',
    color: INCIDENCE_ICON_COLORS.red,
  },
  'Accidente de trayecto': {
    icon: 'car',
    color: INCIDENCE_ICON_COLORS.red,
  },
  'Días de castigo': {
    icon: 'gavel',
    color: INCIDENCE_ICON_COLORS.red,
  },
  'Día festivo trabajado': {
    icon: 'calendar-star',
    color: INCIDENCE_ICON_COLORS.green,
  },
  '1 Hora extra': {
    icon: 'timer-plus',
    color: INCIDENCE_ICON_COLORS.green,
  },
  '2 Horas extras': {
    icon: 'timer-plus',
    color: INCIDENCE_ICON_COLORS.green,
  },
  '3 Horas extras': {
    icon: 'timer-plus',
    color: INCIDENCE_ICON_COLORS.green,
  },
  '4 Horas extras': {
    icon: 'timer-plus',
    color: INCIDENCE_ICON_COLORS.green,
  },
  '5 Horas extras': {
    icon: 'timer-plus',
    color: INCIDENCE_ICON_COLORS.green,
  },
  'Vacaciones a pagar': {
    icon: 'airplane-takeoff',
    color: INCIDENCE_ICON_COLORS.green,
  },
  'Incapacidad por maternidad': {
    icon: 'human-pregnant',
    color: INCIDENCE_ICON_COLORS.light_purple,
  },
};

export const INCIDENCES_NAVIGATION_TABS = [
  { label: 'Nómina', routeName: 'nomina', iconLeft: 'folder' },
  { label: 'Incidencias', routeName: 'IncidenciasDePersonal', iconLeft: 'alert' },
];
